import { render, staticRenderFns } from "./WaterNewOneMap.vue?vue&type=template&id=48c1f485&scoped=true"
import script from "./WaterNewOneMap.vue?vue&type=script&lang=js"
export * from "./WaterNewOneMap.vue?vue&type=script&lang=js"
import style0 from "./WaterNewOneMap.vue?vue&type=style&index=0&id=48c1f485&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c1f485",
  null
  
)

export default component.exports